import TYPES from './types'

export default {
  [TYPES.TITLE.SET]: ({ commit }, title) => {
    commit(TYPES.TITLE.SET, title)
  },
  [TYPES.TITLE.DELETE]: ({ commit }) => {
    commit(TYPES.TITLE.DELETE)
  }
}
